import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 19h-8.194a2 2 0 0 1 -1.98 -2.283l1.674 -11.717","key":"svg-0"}],["path",{"d":"M14 9l-9 4","key":"svg-1"}]]

/**
 * IconCurrencyLitecoin
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktbGl0ZWNvaW4iCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE4IDE5aC04LjE5NGEyIDIgMCAwIDEgLTEuOTggLTIuMjgzbDEuNjc0IC0xMS43MTciIC8+CiAgPHBhdGggZD0iTTE0IDlsLTkgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/currency-litecoin
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyLitecoin = createReactComponent('outline', 'currency-litecoin', 'CurrencyLitecoin', __iconNode);

export default IconCurrencyLitecoin;